import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'child-cell',
  template: `
  <span>
    <i class="fa fa-comments edit text-primary" (click)="invokeParentMethod()" title="View Feedback"></i>
  </span>
  `,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class ViewFeedbackButtonRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.params.data['action'] = 'view';
    this.params.context.componentParent.methodFromParent(
        this.params.data
    );
  }

  refresh(): boolean {
    return false;
  }
}